module.exports = __webpack_public_path__ + "img/img_kftc.471975ed.png";